<template>
    <div v-if="device">
        <template v-if="!isClustered">
            <gmap-circle
                    v-if="device.showCircle()"
                    :radius="device.getAccuracy()"
                    :center="device.getLocation()"
                    :options="{
                    fillColor: '#3497FD',
                    fillOpacity: .2,
                    strokeColor: device.getMarker().color,
                    strokeWeight: 3
                }">
            </gmap-circle>
            <rich-marker :position="locationWithCircleOffset()">
                <div class="pin"
                     :class="[
                        'pin_' + device.getMessageIcon(messageIndex),
                        device.getAccuracy() >= 50 ? 'has-circle' : ''
                    ]"
                     @click="clickHandler">
                    <div class="pin_movement-indicator" v-if="device.isMoving()"></div>
                    <i class="e-finder-icons" :class="{'fa-letter': device.iconIsLetter() }">{{ device.getIcon() }}</i>

                    <div class="pin_info-icon"></div>
                </div>
            </rich-marker>
        </template>
        <gmap-marker :position="device.getLocationWithCircleOffset()" :visible="false" ref="marker"></gmap-marker>
    </div>
</template>
<script>
import { gmapApi } from 'vue2-google-maps';
import RichMarker from '../markers/RichMarker';

export default {
  components: {
    RichMarker,
  },
  props: {
    device: {
      type: Object,
      default: null,
    },
  },
  inject: ['deviceClusterer'],
  computed: {
    google: gmapApi,
    messageIndex() {
      return this.$store.state.messageIndex;
    },
  },
  data() {
    return {
      isClustered: true,
    };
  },
  methods: {
    clickHandler(event) {
      this.$emit('click', event);
    },
    locationWithCircleOffset() {
      return new this.google.maps.LatLng(this.device.getLocationWithCircleOffset());
    },
    checkIfClustered() {
      if (!this.$refs.marker || !this.$refs.marker.$markerObject) return;
      this.isClustered = !this.$refs.marker.$markerObject.map;
    },
  },
  mounted() {
    this.$refs.marker.$markerPromise.then((marker) => {
      marker.device = this.device;
      this.google.maps.event.addListener(this.deviceClusterer().$clusterObject, 'clusteringend', this.checkIfClustered);
    });
  }
};
</script>
<style lang="stylus">
    .pin {
        position: relative;
        display: block;
        top: -25px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: solid 5px #F18E00;
        background: #fff;
		z-index: 1;

		// Pulse
		&:before {
			content: '';
			display: none;
			position: absolute;
			top: 50%;
			left: 50%;
			width: 100%;
			height: 100%;
			transform: translate(-50%, -50%);
			background-color: red;
			border-radius: 50%;
			z-index: -1;
		}

        &:after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            width: 0;
            height: 0;
            transform: translateX(-50%)
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 25px solid #F18E00;
        }

		&.has-circle {
			top: 0;
			transform: translateY(50%);
			z-index: 1;

			&:after {
				display: none;
			}
			&:before {
				position: absolute;
				z-index: -1;
			}
		}

        .pin_movement-indicator {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            overflow: hidden;
            border-radius 50%;
            background-color: #FFFFFF;

            &:after,
            &:before {
                position: absolute;
                content: '';
                top: -3px;
                left: -3px;
                bottom: -3px;
                right: -3px;
                border-radius 50%;
                border: solid 3px #9bf;
                animation: ripple 1s linear infinite;
            }
        }

        i.e-finder-icons {
            position: absolute;
            font-size: 2rem;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            &.fa-letter{
                font-family: 'Roboto', sans-serif;
                font-style: normal;
                font-weight: bold;
            }
        }

        .pin_info-icon {
            display: none;
            position: absolute;
            top: -14px;
            right: -14px;
            width: 28px;
            height: 28px;
            background-color: #F18E00;
            border-radius: 50%;
            color: #fff;
            text-align: center;
            line-height: 25px;
            font-size: 11px;
            font-weight: normal;
        }
    }

	.pin.pin_range-detector {
		border-color: #3497FD;
		&:before {
			background-color: #3497FD;
			animation: pulse .5s infinite;
		}
		&:after {
			border-top: 25px solid #3497FD;
		}
		.pin_info-icon {
			display: block;
			background: #3497FD;
			&:before {
				font-family: 'Font Awesome 5 Pro';
				font-size: 1rem;
				line-height: 28px;
				content: '\f1eb';
			}
		}
	}

    .pin.pin_security-service-mode {
        border-color: #DB0000;
		&:before {
			background-color: #DB0000;
			animation: pulse .5s infinite;
		}
        &:after {
            border-top: 25px solid #DB0000;
        }
        .pin_info-icon {
            display: block;
            background: #DB0000;
            &:before {
                content: 'smc';
            }
        }
    }

    .pin.pin_armed-state {
        .pin_info-icon {
            display: block;
            background: #F18E00;
            &:before {
                content: '';
            }
        }
    }

    .pin.pin_location-lock {
        .pin_info-icon {
            display: block;
            background: #F18E00;
            &:before {
                font-family: 'Font Awesome 5 Pro';
                font-size: 1rem;
                line-height: 28px;
                content: '\f023';
            }
        }
    }

    .pin.pin_battery-critical,
    .pin.pin_battery-low {
		.pin_info-icon {
			display: block;
			background: #F18E00;

			&:before {
				font-family: 'Font Awesome 5 Pro';
				font-size: .9rem;
				line-height: 28px;
				content: '\f243';
			}
		}
	}

	.pin.pin_battery-critical {
		border-color: #DB0000;
		&:before {
			background-color: #DB0000;
		}
		&:after {
			border-top: 25px solid #DB0000;
		}
		.pin_info-icon {
			background: #DB0000;
		}
	}

	@keyframes pulse {
		0% {
			transform: translate(-50%, -50%) scale(1);
			opacity: 0;
		}
		100% {
			transform: translate(-50%, -50%) scale(1.75);
			opacity: .25;
		}
	}

    @keyframes spin {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes ripple {
        0% {
            transform: scale(.5);
            opacity: 0;
        }
        100% {
            transform: scale(1);
            opacity: .75;
        }
    }
</style>
